module.exports = __webpack_public_path__ + "assets/img/desc-img.70b2be59.png";